import { DetectionConfigurationCard } from 'features/anomalyDetection/components/DetectionConfigurationCard'
import { GeckoNotificationProvider } from 'features/notifications'
import React from 'react'

interface AnomalyDetectionProps {
  siteID: string
}

export const AnomalyDetection: React.FC<AnomalyDetectionProps> = ({
  siteID,
}) => {
  return (
    <GeckoNotificationProvider>
      <DetectionConfigurationCard siteID={siteID} />
    </GeckoNotificationProvider>
  )
}
